<template>
  <div>
    <v-dialog persistent v-model="value" max-width="1300px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Crear Comunicados</span>
        </v-card-title>
        <v-card-text style="max-height: 700px">
          <v-layout wrap>
            <v-flex xs12>
              <v-stepper v-model="e1" class="elevation-0">
                <v-stepper-header>
                  <v-stepper-step :complete="e1 > 1" :step="1">
                    Datos
                  </v-stepper-step>
                  <v-divider />
                  <v-stepper-step :complete="e1 > 2" :step="2">
                    Audiencia
                  </v-stepper-step>
                  <v-divider />
                  <v-stepper-step :complete="e1 > 3" :step="3">
                    Completado
                  </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content :step="1">
                    <v-layout row wrap justify-center>
                      <v-flex xs12>
                        <Type
                          v-model="noticeForm"
                          :v="$v.noticeForm"
                          :clear="value"
                        />
                      </v-flex>
                    </v-layout>
                  </v-stepper-content>

                  <v-stepper-content :step="2">
                    <NoticeBroadcast
                      :cancel="flags.cancel"
                      :section="'COMMUNITY'"
                      @selected="selectionAudiency"
                    />
                  </v-stepper-content>

                  <v-stepper-content :step="3">
                    <detailNotice
                      :notice="noticeForm"
                      :v="$v.noticeForm"
                      :clear="value"
                    />
                  </v-stepper-content>
                </v-stepper-items>
                <alert
                  v-model="toast.alert"
                  title="Aviso"
                  :description="toast.description"
                />
              </v-stepper>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="disabled"
            :disabled="e1 == 1"
            color="primary"
            @click="back"
            icon
          >
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn v-if="disabled" @click="close" flat> Cancelar </v-btn>
          <v-spacer />
          <v-btn v-if="disabled && e1 < 3" color="primary" @click="next" icon>
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <v-btn
            v-if="e1 == 3"
            small
            color="primary"
            @click="next"
            :disabled="creating"
          >
            {{
              noticeForm.sentToSchedule == true && permits['CONFIRM_NOTICE']
                ? 'Programar'
                : noticeForm.sentToSchedule == true &&
                  !permits['CONFIRM_NOTICE']
                ? 'Mandar autorizar'
                : noticeForm.sentToSchedule == false
                ? 'Guardar como borrador'
                : ''
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals2.confirma" persistent max-width="600px">
      <v-card>
        <v-card-title
          class="headline gradiente lighten-2 elevation-3 justify-center"
        >
          <span class="white--text">{{ modals2.title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout class="justify-center">
              <h4 class="justify-center">
                {{ modals2.descripcion }}
              </h4>
            </v-layout>
            <br />
            <br />
            <v-layout class="justify-center">
              <h3>{{ modals2.question }}</h3>
            </v-layout>
            <br />
            <v-layout class="justify-center">
              <v-btn class="primary" @click="modals2.confirma = false">
                Cancelar
              </v-btn>
              <v-btn
                color="black"
                dark
                @click="
                  createNotice2()
                  modals2.confirma = false
                "
              >
                {{ this.modals2.btnText }}
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Type from '../Sections/Notices/Type2'
// import data from "../Sections/Notices/Data";
// import EventDates from "../Sections/Notices/EventDates";
import moment from 'moment'
import { mapGetters } from 'vuex'
import alert from '../Dialogs/Alert'
import detailNotice from '../Sections/Notices/Details2'
import NoticeBroadcast from '../Tools/Audience'

export default {
  components: {
    Type,
    // NoticeData: data,
    // EventDates,
    // NoticeImage,
    NoticeBroadcast,
    alert,
    detailNotice,
  },
  mounted() {
    if (this.getUser.id) {
      this.mapPermits()
      if (!this.permits['WATCH_NOTICE']) {
        this.toast.failed = true
      }
    }
  },
  validations: {
    noticeForm: {
      type: { required },
      title: { required },
      description: { required },
      startDate: { required },
      endDate: {
        validateDateEnd() {
          if (this.noticeForm.endDate) {
            return this.noticeForm.startDate < this.noticeForm.endDate
              ? true
              : false
          }
          return true
        },
        required,
      },
      place: { required },
      confirmParent: {},
      assistanceRequired: {
        validateAssistenceRequired() {
          if (this.noticeForm.type == 'E') {
            if (
              this.noticeForm.assistanceRequired == false &&
              this.noticeForm.attendanceStudentRequired == false
            ) {
              return false
            }
          }
          return true
        },
      },
      //nuevos campos v2
      startEventDate: {
        validateDateStartEvent() {
          if (this.noticeForm.startEventDate) {
            if (
              this.noticeForm.startDate <= this.noticeForm.startEventDate &&
              this.noticeForm.startEventDate < this.noticeForm.endDate
            ) {
              return true
            } else {
              return false
            }
          }
          return true
        },
        required,
      },
      authParentRequired: {},
      sentToSchedule: {},
      imageStorage: {},
      files: {},
      permits: [],
      attendanceStudentRequired: {
        validateAssistenceRequired() {
          if (this.noticeForm.type == 'E') {
            if (
              this.noticeForm.assistanceRequired == false &&
              this.noticeForm.attendanceStudentRequired == false
            ) {
              return false
            }
          }
          return true
        },
      },
      employeeAudience: {},
    },
  },
  props: ['value'],
  watch: {
    value() {
      if (this.value && this.flags.cancel) {
        this.flags.cancel = false
      }
    },
    getUser() {
      this.mapPermits()
      if (!this.permits['WATCH_NOTICE']) {
        this.toast.failed = true
      }
    },
  },
  data: () => ({
    e1: 0,
    noticeForm: {
      type: 'E',
      title: '',
      description: '',
      startDate: '',
      endDate: '',
      levels: [],
      students: [],
      groups: [],
      institutional: false,
      place: '',
      confirmParent: false,
      assistanceRequired: false,
      files: [],
      //nuevos campos agregados v2
      authParentRequired: false,
      startEventDate: '',
      sentToSchedule: false,
      subgroups: [],
      imageStorage: [],
      employeeAudience: [],
      attendanceStudentRequired: false,
    },
    toast: {
      alert: false,
      description: '',
    },
    flags: {
      cancel: false,
    },
    typeBroadcast: '',
    disabled: true,
    textSchedule: 'GUARDAR',
    permits: [],

    modals2: {
      title: 'AVISO',
      descripcion: '',
      confirma: false,
      question: '',
      btnText: '',
    },
    clear: false,
    creating: false,
  }),
  methods: {
    close() {
      this.clear = true
      this.noticeForm = {
        type: 'E',
        title: '',
        description: '',
        startDate: '',
        endDate: '',
        levels: [],
        students: [],
        groups: [],
        place: '',
        confirmParent: false,
        imageStorage: [],
        //Asistencia del tutor
        assistanceRequired: false,
        img: '',
        files: [],
        // nuevos campos v2
        employeeAudience: [],
        authParentRequired: false,
        startEventDate: '',
        sentToSchedule: false,
        subgroups: [],
        //assitencia del alumno
        attendanceStudentRequired: false,
      }
      this.disabled = true
      this.flags.cancel = true
      this.e1 = 1
      this.$v.noticeForm.$reset()
      this.$emit('input', false)
      this.creating = false
    },
    next() {
      switch (this.e1) {
        case 1:
          //validando titulo y descripcion
          this.$v.noticeForm.title.$touch()
          this.$v.noticeForm.description.$touch()
          //validando inputs de fechas del evento
          this.$v.noticeForm.startDate.$touch()
          this.$v.noticeForm.endDate.$touch()

          this.$v.noticeForm.startEventDate.$touch()
          this.$v.noticeForm.assistanceRequired.$touch()
          this.$v.noticeForm.attendanceStudentRequired.$touch()
          if (this.canContinue()) {
            this.e1++
          }
          break
        case 2:
          if (
            this.noticeForm.students.length > 0 ||
            this.noticeForm.groups.length > 0 ||
            this.noticeForm.levels.length > 0 ||
            this.noticeForm.institutional ||
            this.noticeForm.subgroups.length > 0 ||
            this.noticeForm.employeeAudience.length > 0
          ) {
            this.e1++
          } else {
            this.toast.description =
              'Debes agregar ya sea la institución o al menos un nivel, grupo, estudiante o colaborador'
            this.toast.alert = true
          }
          break
        case 3: // mandar alerta si el check de sendToSchedule es true o se va a mandar a programar
          if (this.canContinue()) {
            if (this.noticeForm.sentToSchedule == true) {
              this.confirmModalNotice()
            } else {
              this.createNotice2()
            }
            break
          }
      }
    },
    canContinue() {
      return (
        !this.$v.noticeForm.title.$invalid &&
        !this.$v.noticeForm.assistanceRequired.$invalid &&
        !this.$v.noticeForm.attendanceStudentRequired.$invalid &&
        !this.$v.noticeForm.description.$invalid &&
        !this.$v.noticeForm.startDate.$invalid &&
        !this.$v.noticeForm.endDate.$invalid &&
        !(
          this.$v.noticeForm.type.$model === 'E' &&
          this.$v.noticeForm.startEventDate.$invalid
        )
      )
    },
    back() {
      this.e1--
    },
    selectionAudiency(event) {
      this.noticeForm.levels = event.levels
      this.noticeForm.groups = event.ggs
      this.noticeForm.students = event.students
      this.noticeForm.institutional = event.institutional
      this.typeBroadcast = event.type
      this.noticeForm.employeeAudience = event.webRoleIds
      this.noticeForm.subgroups = event.subgroupIds
    },
    createNotice() {
      this.disabled = false
      this.$emit('loading')
      var notice = {
        type: this.noticeForm.type,
        title: this.noticeForm.title,
        description: this.noticeForm.description,
        startDate: this.noticeForm.startDate,
        endDate: this.noticeForm.endDate,
        institutional: this.noticeForm.institutional,
        levels: this.noticeForm.levels,
        students: this.noticeForm.students,
        groups: this.noticeForm.groups,
        place: this.noticeForm.place,
        confirmParent: this.noticeForm.confirmParent,
        assistanceRequired: this.noticeForm.assistanceRequired,
        imageStorage: this.noticeForm.imageStorage,
        files: this.noticeForm.files,
        branch: {
          id: this.$store.getters.getBranch.id,
        },
        // nuevos campos v2
        //authParentRequired: this.authParentRequired,
        //sentToSchedule : this.noticeForm.sentToSchedule,
      }
      this.$store
        .dispatch('notice/createNotice', notice)
        .then((response) => {
          this.$emit('success')
          this.disabled = true
          this.close()
        })
        .catch((error) => {
          this.disabled = true
          this.$emit('failed')
          console.log(error)
        })
    },
    createNotice2() {
      this.disabled = false
      this.$emit('loading')
      this.noticeForm.type =
        this.noticeForm.type == 'A' && this.noticeForm.confirmParent == true
          ? 'R'
          : this.noticeForm.type
      this.noticeForm.confirmParent =
        this.noticeForm.type == 'R' ? false : this.noticeForm.confirmParent
      this.noticeForm.confirmParent =
        this.noticeForm.type == 'E' ? true : this.noticeForm.confirmParent
      var notice = {
        type: this.noticeForm.type,
        title: this.noticeForm.title,
        description: this.noticeForm.description,
        startDate: this.noticeForm.startDate,
        endDate: this.noticeForm.endDate,
        institutional: this.noticeForm.institutional,
        levels: this.noticeForm.levels,
        students: this.noticeForm.students,
        groups: this.noticeForm.groups,
        place: this.noticeForm.place,
        confirmParent: this.noticeForm.confirmParent,
        assistanceRequired: this.noticeForm.assistanceRequired,
        imageStorage: this.getImages(),
        files: this.noticeForm.files,
        branch: {
          id: this.$store.getters.getBranch.id,
        },
        // nuevos campos v2
        authParentRequired: this.noticeForm.authParentRequired,
        sentToSchedule: this.noticeForm.sentToSchedule,
        startEventDate:
          this.noticeForm.startEventDate == '' && this.noticeForm.type == 'E'
            ? this.noticeForm.startDate
            : this.noticeForm.startEventDate,
        subgroups: this.noticeForm.subgroups,
        //Descomentar para nueva version
        //asistencia del estudiante
        attendanceStudentRequired: this.noticeForm.attendanceStudentRequired,
        //audiencia de colaboradores
        employeeAudience: this.noticeForm.employeeAudience,
      }
      this.creating = true
      this.$store
        .dispatch('notice/createNewNotice', notice)
        .then((response) => {
          GoogleAnalytics.actionEvent({
            eventName: 'created_notice',
            eventDescription: 'Encuesta creada',
          })
          this.$emit('success')
          this.disabled = true
          this.close()
        })
        .catch((error) => {
          this.disabled = true
          this.$emit('failed')
          console.log(error)
          this.creating = false
        })
    },
    getImages() {
      var images = []
      var imageStorages = this.noticeForm.imageStorage
      if (imageStorages) {
        imageStorages.forEach((it) => {
          images.push({ img: it.img })
        })
      }
      return images
    },
    mapPermits() {
      var usr = this.getUser
      var wbRol = usr.webRole
      var catalogs = wbRol.catalogs
      for (var c in catalogs) {
        if (catalogs[c].name.includes('NOTICE')) {
          this.permits[catalogs[c].name] = 1
        }
      }
    },
    confirmModalNotice() {
      this.modals2.tittle = 'AVISO'
      if (this.permits['CONFIRM_NOTICE']) {
        this.modals2.descripcion =
          'Se procederá a Programar el comunicado con la fecha y hora de inicio: ' +
          this.dateFormat2(this.noticeForm.startDate) +
          '\n finalización en la fecha: ' +
          this.dateFormat2(this.noticeForm.endDate)
        this.modals2.question = '\n ¿Deseas proceder a Programar el comunicado?'
        this.modals2.btnText = 'Si, programar'
      } else {
        this.modals2.descripcion =
          'El comunicado debe ser autorizado por un administrador'
        this.modals2.question =
          '\n ¿Deseas proceder a enviar a autorización el comunicado?'
        this.modals2.btnText = 'Si, enviar a autorización'
      }
      this.modals2.confirma = true
    },
    dateFormat2(value) {
      return moment(String(new Date(value))).format('DD/MM/YYYY HH:mm')
    },
  },
  computed: {
    ...mapGetters(['getUser']),
  },
}
</script>

<style></style>
